var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"id":"barcode_listner","loading":_vm.loading,"icon":""},on:{"click":function () {
    _vm.keyPressSwitch = !_vm.keyPressSwitch
    _vm.keyPressInput = ''
  }}},[_c('v-icon',{attrs:{"color":_vm.iconColor},domProps:{"textContent":_vm._s(_vm.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }